const assets = [
    {
        title: "Medical Courier Vans",
        img: "/assets/medical-courier-van.png",
        alt: "White medical courier van driving on a highway in daylight",
        desc: "Purpose-specced cargo vans for time-critical medical routes — specimens, pharmaceuticals, and lab logistics.",
        chips: ["Cargo Vans", "Medical Routes", "Time-Critical"],
        testid: "asset-card-medical-courier",
    },
    {
        title: "Courier Vehicles",
        img: "https://images.unsplash.com/photo-1771582968323-eb0c3c4034cc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
        alt: "Courier van driving on a highway",
        desc: "Reliable last-mile and regional courier vehicles leased to operators running daily delivery routes.",
        chips: ["Last-Mile", "Regional Routes", "Daily Service"],
        testid: "asset-card-courier-vehicles",
    },
    {
        title: "RV Fleet",
        img: "https://images.unsplash.com/photo-1787132331234-cdb380cb750f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
        alt: "Rental RV motorhome driving on a scenic highway",
        desc: "Rental RVs and motorhomes generating revenue through the operating partner's rental program.",
        chips: ["Motorhomes", "Rental Program", "Revenue Units"],
        testid: "asset-card-rv-fleet",
    },
    {
        title: "Pilot Cars for Oversized Loads",
        img: "/assets/pilot-car.png",
        alt: "Pilot escort car with amber roof light bar and yellow OVERSIZED LOAD banner driving ahead of a flatbed trailer hauling a large mobile home on a highway",
        desc: "Escort vehicles with amber light bars and oversize-load banners, running ahead of heavy-haul freight.",
        chips: ["Escort Vehicles", "Oversized Loads", "Highway Certified"],
        testid: "asset-card-pilot-cars",
        imgTestId: "pilot-car-image",
    },
];

export default function AssetClasses() {
    return (
        <section id="assets" data-testid="assets-section" className="py-24 px-6 bg-[#121620]">
            <div className="max-w-7xl mx-auto">
                <p className="font-mono2 text-xs uppercase tracking-widest text-amber-500 mb-4">
                    What We&rsquo;re Buying
                </p>
                <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white mb-14">
                    Four asset classes, one owner
                </h2>
                <div className="grid sm:grid-cols-2 gap-8">
                    {assets.map((a) => (
                        <article
                            key={a.testid}
                            data-testid={a.testid}
                            className="img-frame group border border-white/10 bg-white/[0.03] rounded-lg overflow-hidden"
                        >
                            <div className="h-60 overflow-hidden">
                                <img
                                    src={a.img}
                                    alt={a.alt}
                                    data-testid={a.imgTestId}
                                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                                />
                            </div>
                            <div className="p-7">
                                <h3 className="font-display text-xl sm:text-2xl font-semibold text-white mb-3">
                                    {a.title}
                                </h3>
                                <p className="text-sm text-slate-300 leading-relaxed mb-5">
                                    {a.desc}
                                </p>
                                <div className="flex flex-wrap gap-2">
                                    {a.chips.map((c) => (
                                        <span
                                            key={c}
                                            className="font-mono2 text-[11px] uppercase tracking-wider text-slate-400 border border-white/10 px-3 py-1 rounded-full"
                                        >
                                            {c}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
